import { ResourceDefinitions } from './ResourceDefinitionContext'
import { useResourceDefinitionContext } from './useResourceDefinitionContext'

export const useResourceDefinitions = (): ResourceDefinitions =>
  useResourceDefinitionContext().definitions
